import React from 'react';
import { withRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import styles from './EventContainer.module.scss';
import { BsTrash } from 'react-icons/bs';
import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useDeleteEvent } from 'legacy/events/hooks';

const EventPreview = ({ event, router, onEventDelete }) => {
  const { t } = useTranslation(['users']);
  const { _id, title, photo, startDate, host, isDraft, isOrganizer } = event;
  const { _id: hostId, name, firstName } = host;
  let { url } = photo;
  const imageStyles = {};
  const deleteEventCommand = useDeleteEvent();

  const onDeleteDraft = () => {
    Modal.confirm({
      title: t('users:profile.events.deleteConfirm.title'),
      icon: <ExclamationCircleOutlined />,
      content: t('users:profile.events.deleteConfirm.message', {
        title: title ? `: "${title}"` : ''
      }),
      centered: true,
      okText: t('users:profile.events.deleteConfirm.yes'),
      okType: 'danger',
      cancelText: t('users:profile.events.deleteConfirm.no'),
      onOk() {
        deleteEventCommand.mutate(_id, {
          onSuccess: () => onEventDelete(_id)
        });
      }
    });
  };

  if (!url) {
    url = '/img/events/portrait-cover.svg';
    Object.assign(imageStyles, {
      backgroundSize: '100px',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundColor: '#F0F3FF'
    });
  }

  let dateLabel = '';
  let timeLabel = '';
  if (startDate) {
    dateLabel = moment(startDate).format('MMM DD');
    timeLabel = moment(startDate).format('h:mm a');
  }

  return (
    <div
      className={styles.eventPreview}
      onClick={() => {
        if (isOrganizer) {
          if (isDraft) {
            router.push(`/events/${_id}?view=edit`);
          } else {
            router.push(`/events/${_id}/dashboard`);
          }
        } else {
          router.push(`/events/${_id}`);
        }
      }}
    >
      <div
        className={styles.image}
        style={{
          backgroundImage: `url(${url})`,
          ...imageStyles
        }}
      />
      <div className={styles.date}>{`${dateLabel} ${timeLabel}`}</div>
      <div className={styles.title}>{title || t('users:profile.events.draftEvent')}</div>
      {hostId && (
        <div
          className={styles.host}
          onClick={(e) => {
            e.stopPropagation();
            router.push(`/profile/${hostId}`);
          }}
        >{t('users:profile.events.hostedBy', { name: firstName || name })}</div>
      )}
      {isDraft && (
        <>
          <div
            className="absolute top-1/2 left-3/4 z-50 text-gray-900 text-7xl font-bold transform -translate-x-3/4 -translate-y-1/2 rotate-45 pointer-events-none bg-white opacity-90"
          >
            {t('users:profile.events.draft')}
          </div>
          <div
            className="absolute top-1 left-1 z-50 bg-white opacity-90 rounded-full p-2 cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              onDeleteDraft();
            }}
          >
            <BsTrash size={24} />
          </div>
        </>
      )}
    </div>
  );
};

export default withRouter(EventPreview);
